export default {
  brands: [],
  models: [],
  fetching: {
    brands: false,
    models: false,
  },
};
